module.exports = __webpack_public_path__ + "media/images/prof_sidebar_top-b37982b6f2467d3044ae100916f9d398.png";